export default {
    verify: function (data, type) {
        switch (type) {
            case 'mail':
                return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(data);
            case 'phone':
                return /^[1]([3-9])[0-9]{9}$/.test(data);
        }
    }
};